import get from "lodash/get";

function createApiAction(type, response, message = "", options = {}) {
  // Potentially `response` is empty or malformed on failed api call.
  const { serviceArgs = [] } = options;
  return {
    payload: {
      message,
      response,
      serviceArgs,
      // For legacy compatibility.
      data: get(response, "data.data", []),
    },
    type,
  };
}

/**
 * Trigger an api call as a promise.
 *
 * @param {Function} dispatch - Redux dispatch function.
 * @param {String} actionType - Fetch Api action type.
 * @param {Array} [serviceArgs] - Arguments to be passed to the service call.
 * @param {String} [successMessage] - Success message.
 *
 * @return {Promise} Promise
 */
function createPromiseApiAction(
  dispatch,
  actionType,
  serviceArgs,
  successMessage,
) {
  return new Promise((resolve, reject) => {
    dispatch({
      payload: {
        resolve,
        reject,
        serviceArgs,
        successMessage,
      },
      type: actionType,
    });
  });
}

export { createApiAction, createPromiseApiAction };
